import { Badge } from 'react-bootstrap'

const SideMenuImpersonate = ({user}: {user: {agent?: string}}) => {
    return (
        user.agent && (
            <Badge pill bg={'warning'} as={'h1'} className={'p-3 text-body'}>
                <strong>Agent: {user.agent}</strong>
            </Badge>
        )
    )
}

export default SideMenuImpersonate
